import { Link } from "react-router-dom";
import {
  ArrowUpRight,
  Rat,
  Zap,
  CircleDot,
  Footprints,
  Bug,
  Crosshair,
  TreePine,
  BedDouble,
} from "lucide-react";
import { HeroLines, Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { PESTS } from "../data/content";

const ICONS = { Rat, Zap, CircleDot, Footprints, Bug, Crosshair, TreePine, BedDouble };

export default function Interventions() {
  return (
    <main>
      <section data-testid="interventions-header" className="hexa-bg overflow-hidden border-b border-black">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 pt-32 md:pt-40 pb-16 md:pb-20">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">
            [ Interventions ]
          </p>
          <HeroLines
            className="font-display uppercase leading-[0.9] tracking-tight text-[15vw] md:text-[9rem] mt-6"
            lines={[{ text: "Nos cibles" }]}
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-600">
              Chaque intervention commence par un
              diagnostic précis et se termine par un traitement durable.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="interventions-list">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8">
          {PESTS.map((pest, i) => {
            const Icon = ICONS[pest.icon];
            return (
              <Reveal key={pest.id} delay={0.05}>
                <article
                  data-testid={`intervention-row-${pest.id}`}
                  className="group grid gap-6 lg:grid-cols-12 items-start border-b border-black py-12 md:py-16"
                >
                  <div className="lg:col-span-1">
                    <span className="font-display text-2xl text-neutral-300 transition-colors duration-300 group-hover:text-[#E50914]">
                      {pest.num}
                    </span>
                  </div>
                  <div className="lg:col-span-4">
                    <div className="flex items-center gap-4">
                      <span className="inline-flex h-12 w-12 items-center justify-center border border-black transition-colors duration-300 group-hover:bg-black">
                        <Icon className="h-6 w-6 transition-colors duration-300 group-hover:text-[#E50914]" />
                      </span>
                      <h2 className="font-display uppercase text-3xl md:text-4xl tracking-tight">
                        {pest.name}
                      </h2>
                    </div>
                    <p className="mt-4 inline-block bg-black text-white text-xs font-semibold uppercase tracking-[0.15em] px-3 py-2">
                      {pest.price}
                    </p>
                  </div>
                  <div className="lg:col-span-4">
                    <p className="text-base text-neutral-600">{pest.detail}</p>
                  </div>
                  <div className="lg:col-span-3">
                    {pest.image && (
                      <div className="overflow-hidden border border-black">
                        <img
                          src={pest.image}
                          alt={pest.name}
                          loading="lazy"
                          className="h-44 w-full object-cover grayscale transition-all duration-500 group-hover:grayscale-0 group-hover:scale-105"
                          data-testid={`intervention-image-${pest.id}`}
                        />
                      </div>
                    )}
                    <Link
                      to="/contact"
                      data-testid={`intervention-devis-${pest.id}`}
                      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.15em] border-b-2 border-[#E50914] pb-1 transition-colors duration-300 hover:text-[#E50914]"
                    >
                      Demander un devis <ArrowUpRight className="h-4 w-4" />
                    </Link>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <Marquee />

      <section className="py-24 md:py-32">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <h2 className="font-display uppercase leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
              Votre nuisible n'est pas dans la liste ?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link
              to="/contact"
              data-testid="interventions-contact-button"
              className="inline-flex items-center gap-3 bg-black text-white px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] transition-colors duration-300 hover:bg-[#E50914]"
            >
              Contactez-nous <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
